module.exports = __webpack_public_path__ + "img/company_none.6f963f14.png";